import { API_DEFAULT_RETRIES, KEVALIN_COLLECTIONS } from 'appConstants';
import { Action, Dispatch } from 'redux';
import { ApiRequest, MailUtils, KevalinUtils } from 'services';
import { SurveyFeedback } from 'types';

export interface InterceptAction extends Action {
  readonly isInterceptOpen?: boolean;
}

export interface InterceptModal {
  isInterceptOpen: boolean;
}

const initialState = {
  isInterceptOpen: false,
} as InterceptModal;

enum Actions {
  OPEN_INTERCEPT_SURVEY = 'OPEN_INTERCEPT_SURVEY',
  CLOSE_INTERCEPT_SURVEY = 'CLOSE_INTERCEPT_SURVEY',
}

const openInterceptSurvey = (): InterceptAction => ({
  type: Actions.OPEN_INTERCEPT_SURVEY,
});

const closeInterceptSurvey = (): InterceptAction => ({
  type: Actions.CLOSE_INTERCEPT_SURVEY,
});

const interceptReducer = (state = initialState, action: InterceptAction) => {
  switch (action.type) {
    case Actions.OPEN_INTERCEPT_SURVEY:
      return {
        ...state,
        isInterceptOpen: true,
      };
    case Actions.CLOSE_INTERCEPT_SURVEY:
      return {
        ...state,
        isInterceptOpen: false,
      };
    default:
      return state;
  }
};

const storeInterceptSurveyMetrics = (
  feedback: SurveyFeedback,
  latestTicketId: string,
) => async (dispatch: Dispatch<InterceptAction>) => {
  const payload = {
    eventData: {
      ...MailUtils.setSurveyPayload(feedback),
      latestTicketId: latestTicketId,
      eventType: 'INTERCEPT',
    },
  };
  return ApiRequest.post(
    KevalinUtils.getKevalinURL(KEVALIN_COLLECTIONS.CTUI_PREFERENCES),
    payload,
    {
      retries: API_DEFAULT_RETRIES,
    },
  );
};

export {
  interceptReducer,
  closeInterceptSurvey,
  openInterceptSurvey,
  storeInterceptSurveyMetrics,
};
